import { useMemo } from "react";

import { Box } from "@chakra-ui/react";

import { useParams } from "react-router-dom";

import { ListQuerySchema } from "@/jenesys-types/data/communication";
import { DataType } from "@/jenesys-types/data/enums";
import { EntityRouteListIds } from "@/jenesys-types/list";

import { CrudListContextProvider } from "@/components/common/crud/CrudList/CrudListContext";
import { CrudListFooter } from "@/components/common/crud/CrudList/CrudListFooter";
import { useCompany } from "@/hooks/util/useCompany";

import { QueriesTable } from "./QueriesTable";

interface QueriesListProps {
  context: "company" | "client";
}

export const QueriesList = ({ context }: QueriesListProps) => {
  const { clientId } = useParams();
  const { activeCompanyId, activeClientId } = useCompany();

  // Determine the company ID based on context
  const companyId =
    context === "company" ? activeCompanyId : activeClientId || clientId;

  const pathParams = useMemo(
    () => ({
      companyId
    }),
    [companyId]
  );

  if (!companyId) {
    return null;
  }

  return (
    <CrudListContextProvider<ListQuerySchema>
      dataType={DataType.CommunicationsQuery}
      listId={EntityRouteListIds.CommunicationQueries}
      pathParams={pathParams}
    >
      <Box>
        <QueriesTable context={context} />
        <CrudListFooter />
      </Box>
    </CrudListContextProvider>
  );
};
